import { IFormStore } from 'src/core/classes/helpers/store/Interfaces'

export const createItem = <T>(
  currentForm: T[],
  row: T,
  query: string,
  dataStore: IFormStore<T>,
  hierarchyField?: string
) => {
  currentForm.push(row)
  if (!query && hierarchyField) {
    Object.keys(dataStore.queries).forEach((key) => {
      const currentQuery = dataStore.queries[key]
      if (currentQuery && currentQuery.groups) {
        currentQuery.groups.map((group) => {
          if (group[0] && group[0][hierarchyField] === row[hierarchyField]) {
            group.push(row)
          }
          return group
        })
      }
    })
  }
}
